export default {"src":"/_next/static/media/PostgreSQL.aa0ac7a8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};